export enum OfferAlertVariant {
  PriceIncreaseV2 = 'PriceIncreaseV2',
  PriceDropV2 = 'PriceDropV2'
}
